module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[119]118.6d1707c.woff2";